import clsx from 'clsx'
import { Fragment } from 'react'

import { useActiveFilterSummaries } from '@/features/shipment-filters/hooks/useFilterDescriptions'

import type { FilterConfig } from './types'

type ActiveFiltersSummaryProps = {
  queryString: string
  filterConfig: FilterConfig[]
}

export const ActiveFiltersSummary = ({
  queryString,
  filterConfig,
}: ActiveFiltersSummaryProps) => {
  const activeFilters = useActiveFilterSummaries(filterConfig, queryString)

  if (activeFilters.length === 0) return null

  return (
    <div
      className={clsx(
        'text-sm italic bg-white p-2 -mt-[calc(1rem+1px)] -mx-6 px-6 mb-4',
        'border-b-fv-blue-200 border-b border-t border-t-fv-gray-300',
        'relative z-10 border-fv-beer-medium',
      )}
    >
      <div className="flex items-center gap-2 flex-wrap">
        <div className="flex items-center">Shipment criteria:</div>

        {activeFilters.map((filter, index) => (
          <Fragment key={index}>
            <div className="bg-fv-beer-light border border-fv-beer-medium rounded-sm px-2 flex items-center gap-x-1">
              <span>{filter.label}: </span>
              {filter.values.map((value, valueIndex) => (
                <Fragment key={valueIndex}>
                  {valueIndex > 0 && (
                    <span className="items-center text-fv-gray-dark inline-flex text-xs ">
                      <span className="underline mb-[.1rem]">or</span>
                    </span>
                  )}
                  <span className="font-medium">{value}</span>
                </Fragment>
              ))}
            </div>
            {index < activeFilters.length - 1 && (
              <span className="text-fv-gray-dark bg-fv-blue/10 text-xs border-fv-gray-dark/30 border px-1 rounded-xs">
                ...and
              </span>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
}
